export default __webpack_public_path__ + "static/media/Right-Grain.324d7c18.PNG";